import { Category, Listing, OfferType } from '@smg-real-estate/hg-rets-schema';

import { isLocationValidForUbs } from '../functions/helpers';

/**
 * Checks whether the listing fully matches the defined specifications of the partner.
 */
export const isListingValidForUbsWidget = (listing: Listing): boolean => {
  // only buy objects
  const isValidOfferType = listing?.offerType === OfferType.Buy;

  // exclude categories
  const isValidCategory = !listing?.categories?.some((category) =>
    Category.ParkingSpace.includes(category),
  );

  return isValidOfferType && isValidCategory && isLocationValidForUbs(listing);
};
